/* The Vault NYC — mobile conversion pass (Sep 17 2026). Loaded with defer. */
(function () {
  var phone = window.matchMedia('(max-width: 600px)');

  /* ------------------------------------------------------------
     1. PRODUCT PAGE — sticky buy bar whenever the main button is
        off screen (above or below), with a size guard.
     ------------------------------------------------------------ */
  (function () {
    var root = document.querySelector('.vault-product');
    if (!root) return;
    var bar = root.querySelector('#vpBuybar');
    var mainBtn = root.querySelector('#vpAcquire');
    if (!bar || !mainBtn || !('IntersectionObserver' in window)) return;

    var btnVisible = true;
    var footer = document.querySelector('footer, .shopify-section-group-footer-group');
    var footerVisible = false;

    function update() {
      var on = phone.matches && !btnVisible && !footerVisible;
      bar.classList.toggle('vm-show', on);
      document.body.classList.toggle('vm-has-buybar', phone.matches);
    }
    new IntersectionObserver(function (es) { btnVisible = es[0].isIntersecting; update(); }).observe(mainBtn);
    if (footer) new IntersectionObserver(function (es) { footerVisible = es[0].isIntersecting; update(); }).observe(footer);
    if (phone.addEventListener) phone.addEventListener('change', update);
    update();

    // Size guard: multi-option products must have a choice made before the bar adds to bag
    var selects = root.querySelectorAll('.vp-sel');
    var multi = false;
    selects.forEach(function (s) { if (s.options.length > 1) multi = true; });
    var picked = false;
    selects.forEach(function (s) { s.addEventListener('change', function () { picked = true; }); });
    var barBtn = root.querySelector('#vpBarAcquire');
    if (barBtn && multi) {
      barBtn.addEventListener('click', function (e) {
        if (picked) return;
        e.preventDefault();
        var v = root.querySelector('.vp-variants');
        if (!v) return;
        v.scrollIntoView({ behavior: 'smooth', block: 'center' });
        v.classList.add('vm-flash');
        setTimeout(function () { v.classList.remove('vm-flash'); }, 1800);
        var first = v.querySelector('select');
        if (first) setTimeout(function () { try { first.focus({ preventScroll: true }); } catch (err) {} }, 500);
      }, true);
    }
  })();

  /* ------------------------------------------------------------
     2. COLLECTION — return shoppers to the same place after they
        tap into a piece and hit Back, including "Load More" pages.
     ------------------------------------------------------------ */
  (function () {
    var root = document.querySelector('.vault-collection');
    var grid = root && root.querySelector('#vcGrid');
    if (!grid || !window.sessionStorage) return;

    var KEY = 'vmList:' + location.pathname + location.search;

    function save() {
      try {
        var btn = root.querySelector('[data-vc-next]');
        var note = root.querySelector('.vc-pagenote');
        sessionStorage.setItem(KEY, JSON.stringify({
          html: grid.innerHTML,
          next: btn ? btn.getAttribute('href') : null,
          note: note ? note.textContent : null,
          y: window.scrollY,
          t: Date.now()
        }));
      } catch (e) {}
    }
    grid.addEventListener('click', function (e) { if (e.target.closest('.vc-card')) save(); });

    var nav = (performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || {};
    var isBack = nav.type === 'back_forward';
    var raw = null;
    try { raw = sessionStorage.getItem(KEY); } catch (e) {}
    if (!raw) return;
    if (!isBack) { try { sessionStorage.removeItem(KEY); } catch (e) {} return; }

    var s;
    try { s = JSON.parse(raw); } catch (e) { return; }
    if (!s || Date.now() - s.t > 30 * 60 * 1000) return;

    // Only restore if more than the first page had been loaded
    var tmp = document.createElement('div');
    tmp.innerHTML = s.html;
    if (tmp.querySelectorAll('.vc-card').length > grid.querySelectorAll('.vc-card').length) {
      grid.innerHTML = s.html;
      grid.querySelectorAll('.reveal').forEach(function (c) { c.classList.add('in'); });
      var btn = root.querySelector('[data-vc-next]');
      if (btn) { if (s.next) btn.setAttribute('href', s.next); else btn.remove(); }
      var note = root.querySelector('.vc-pagenote');
      if (note && s.note) note.textContent = s.note;
    }
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    requestAnimationFrame(function () { window.scrollTo(0, s.y); });
  })();
})();

/* ------------------------------------------------------------
   3. LIVE-ONLY DEFAULT (Sep 17 2026)
      Collections and search default to filter.v.availability=1
      (available pieces only). The Vault Archive is exempt.
      Internal links/forms get the filter up front so there is no
      redirect; the inline script in theme.liquid covers anyone
      landing from outside. A shopper who deliberately removes the
      availability filter keeps that choice for the session.
   ------------------------------------------------------------ */
(function () {
  var AV = 'filter.v.availability';
  var RE = /^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/(?:collections\/([^\/]+)|(search))\/?$/i;
  var EXEMPT = /^(archive-1|vendors|types)$/i;

  function eligible(url) {
    if (url.origin !== location.origin) return false;
    var m = url.pathname.match(RE);
    if (!m) return false;
    if (m[1] && EXEMPT.test(m[1])) return false;
    return true;
  }
  function optedOut(path) { try { return !!sessionStorage.getItem('vmSold:' + path); } catch (e) { return false; } }
  function optOut(path) { try { sessionStorage.setItem('vmSold:' + path, '1'); } catch (e) {} }

  var FACET_UI = '.vc-facets-panel, .vc-active-facets, facets-drawer, .facets-sidebar, .active-facets, [is="facet-link"], .vc-pagelinks, .vc-pager, .pagination';
  var CLEAR_ALL = '.vc-chip-clear, .vc-fclear, .vc-empty a';

  // Links: add the filter before navigation (works for links injected later, e.g. search dropdown)
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || a.target === '_blank') return;
    var url;
    try { url = new URL(a.getAttribute('href'), location.href); } catch (err) { return; }
    if (!eligible(url) || url.searchParams.has(AV)) return;

    if (a.closest(FACET_UI)) {
      // A filter/pagination control that drops availability = the shopper chose to see sold pieces
      if (!a.matches(CLEAR_ALL) && new URLSearchParams(location.search).has(AV)) optOut(url.pathname);
      return;
    }
    if (optedOut(url.pathname)) return;
    url.searchParams.set(AV, '1');
    a.setAttribute('href', url.pathname + url.search + url.hash);
  }, true);

  // Sort form: keep every active filter (previously sorting cleared them).
  // The sort <select> submits via form.submit(), which skips submit events, so hook "change" too.
  function carryFilters(f) {
    var have = {};
    f.querySelectorAll('input[type="hidden"]').forEach(function (h) { have[h.name + '=' + h.value] = 1; });
    new URLSearchParams(location.search).forEach(function (v, k) {
      if (k.indexOf('filter.') !== 0 || have[k + '=' + v]) return;
      var h = document.createElement('input'); h.type = 'hidden'; h.name = k; h.value = v; f.appendChild(h);
    });
  }
  document.addEventListener('change', function (e) {
    var f = e.target.closest && e.target.closest('form.vc-sortform');
    if (f) carryFilters(f);
  }, true);

  // GET forms (search boxes, "view all results", sort): carry the filter
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || (f.method || 'get').toLowerCase() !== 'get') return;
    var url;
    try { url = new URL(f.getAttribute('action') || location.pathname, location.href); } catch (err) { return; }
    if (!eligible(url)) return;

    // Vault filter panel: unchecking availability = opt out
    if (f.classList.contains('vc-facets-form')) {
      var box = f.querySelector('input[name="' + AV + '"][value="1"]');
      if (box && !box.checked) optOut(url.pathname);
      return;
    }

    if (f.classList.contains('vc-sortform')) { carryFilters(f); return; }

    if (optedOut(url.pathname) || f.querySelector('[name="' + AV + '"]')) return;
    var i = document.createElement('input'); i.type = 'hidden'; i.name = AV; i.value = '1'; f.appendChild(i);
  }, true);
})();
